module.exports = __webpack_public_path__ + "static/story3-small-thumbnails-100x100-9df8c7d4a8f9e377cedde63f9b5aa84b.jpg";